import { Directive, ElementRef, HostBinding, Input, OnInit, Optional, Self} from '@angular/core';
import { TooltipDirective } from 'ngx-bootstrap/tooltip';

@Directive({
  selector: '[rlAria]'
})
export class AriaDirective implements OnInit{

  @Input() rlAria : string;

  constructor(private ele : ElementRef, @Optional() @Self() private tooltip : TooltipDirective) { }

  @HostBinding("attr.aria-label") ariaLabel : string;

  @HostBinding("value") value : string;

  ngOnInit(): void {
    let val = this.rlAria || this.tooltip?.tooltip || this.ele.nativeElement.innerText;
    
    if(!val){
      console.warn(`you put rlAria but with no value or tooltip on element`);
    }else{
      if(this.ele.nativeElement instanceof HTMLButtonElement)	this.value = val;
    	this.ariaLabel = val;
    }
  }
}
